export default __webpack_public_path__ + "static/media/vip.c41828b0.png";